import axios from "axios";
import { EXTERNAL_API_URL } from "../index";

export const GET_MY_BENEFITS_FOLLOWUP_URL = "Benefits/get-my-benefits-followup";
export const GET_BENEFIT_DETAILS_URL = "Benefits/get-benefit-details";
export const EXPORT_BENEFIT_DETAILS_REPORT_URL = "Benefits/export-benefit-details-report";

export function getMyBenefitsFollowUp(data) {
  return axios.get(EXTERNAL_API_URL + GET_MY_BENEFITS_FOLLOWUP_URL, {
    params: data,
  });
}

export function getBenefitDetails(params) {
  return axios.get(EXTERNAL_API_URL + GET_BENEFIT_DETAILS_URL, {
    params,
  });
}

export function exportBenefitDetailsReport(params) {
  return axios.get(EXTERNAL_API_URL + EXPORT_BENEFIT_DETAILS_REPORT_URL, {
    params,
    responseType: "blob",
  });
}
